//Set All Constant For Fetch Value
export const host_url = 'https://snapcityinpune.com'
export default host_url;
